// Shared cookie policy content and types
export interface CookiePolicySection {
  title: string
  paragraphs?: string[]
  list?: Array<{ title: string; description: string }>
  showOneTrustList?: boolean
}

export interface CookiePolicyContent {
  title: string
  introduction: string
  sections: CookiePolicySection[]
  contact: string
}

// Shared sections used in both policies
export const sharedSections = {
  whatIsACookie: {
    title: 'What is a cookie?',
    paragraphs: [
      "A 'cookie' is a small data file that is stored on your device when you visit a website or perform actions while visiting a website.",
      'Cookies may be set by the website you are visiting (&quot;<strong>first party cookies</strong>&quot;) or may be set by other websites who display content on the page you are viewing (&quot;<strong>third party cookies</strong>&quot;). Third-party cookies enable third-party features or functionality to be provided on or through the website you are visiting (e.g., advertising, interactive content or analytics).',
      'Where we refer to a cookie in this Cookie Policy, this also incorporates similar tracking technologies, such as web beacons, scripts and pixel tags.',
      "Cookies can be useful because they allow a website to recognize a user's device. They are widely used in order to make websites work, or work more efficiently, as well as to provide information to the owners of the site.",
      'Cookies help us understand how you use our website and improve your experience. They also enable us to provide personalized content and remember your preferences.',
    ],
  },
  whatCookiesDoesTPUse: {
    title: 'What cookies does Travelport use and why?',
    list: [
      {
        title: 'Strictly Necessary Cookies',
        description:
          'This Website utilizes strictly necessary cookies that are required for basic website operation, such as to allow page navigation or site access, or to set up essential functionalities to guarantee the security and efficiency of our Website. This Website cannot function properly without these cookies. If these cookies are blocked or disabled by amending your browser settings, our Website may cease to function properly and users may experience reduced or limited functionality.  We do not accept any liability for any loss arising where strictly necessary cookies are blocked. We also utilize non-necessary cookies.  These cookies are used for functionality and analytical purposes, website performance improvement and/or for advertising purposes and help us provide the best user experience. These cookies are detailed below.',
      },
      {
        title: 'Functional Cookies',
        description:
          "These cookies are used to enhance the performance and functionality of our Website but are not essential for the Website's use. They may be set by us or by third party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may become unavailable.",
      },
    ],
  },
  howToManageCookies: {
    title: 'How can I manage the use of cookies',
    paragraphs: [
      'When you visit our Website, you will be prompted via our cookie banner to accept or refuse cookies. You can either accept or reject all cookies or you can customize your cookie options by setting your preferences in the Cookie Preference Center. The Cookie Preference Center allows you to select which categories of cookies you accept or reject. Strictly necessary cookies cannot be rejected as they are essential to provide you with the services the Website provides. The Cookie Preference Center can be found in the cookie banner. If you choose to reject cookies, you may still use our Website but your access to some functionality and areas of the Website may be restricted.',
    ],
  },
  removingCookies: {
    title: 'Removing cookies from your device',
    paragraphs: [
      'You can also delete all cookies that are already on your device by clearing the browsing history of your browser. This will remove all cookies from all websites you have visited. Be aware that by deleting cookies in this way you may also lose some saved information (e.g. saved login details, site preferences).',
    ],
  },
  blockingCookies: {
    title: 'Blocking cookies',
    paragraphs: [
      "You can set most modern browsers to prevent any cookies being placed on your device, but you may then have to manually adjust some preferences every time you visit a site/page. If you do this some services and functionalities may not work properly at all. As the ways by which you can refuse cookies through your web browser controls may vary from browser to browser, you should visit your browser's help menu for more information. Third-party providers that are displaying content on our Website via third-party cookies may at any time change their terms of service, cookie policies and other policies. To control the use of these cookies, you will need to contact the owner of that cookie, which would be the third-party provider.",
    ],
  },
  updatesToPolicy: {
    title: 'Updates to the Cookie Policy',
    paragraphs: [
      'We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal, or regulatory reasons. Please therefore revisit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.',
      '<strong>Effective Date</strong>: 04 February 2026',
    ],
  },
}

export const sharedContact = `If you have any questions about our use of cookies please contact our Privacy Officer at privacy@travelport.com or at the addresses specified below:
Travelport
One Axis Park, 10 Hurricane Way
Langley, Berkshire SL3 8AG
United Kingdom
Attention: Privacy Officer / Legal Department
T: +44 (0) 1753 288000
F: +44 (0) 1753 288001
OR
Travelport
300 Galleria Parkway
Atlanta, Georgia 30039
United States of America
Attention: Privacy Officer / Legal Department
T: +1 770 563 7400
F: +1 770 563 7878
`
